// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__0II_j","item":"Breadcrumbs_item__SPOIC"};